import { Base } from '../base';

export class Check extends Base {
    VehicleCheckID?: string;
    ParkingID?: number;
    FineID?: string;
    Plate?: string;
    Owner?: string;
    Date?: Date;
    Latitude?: number;
    Longitude?: number;
    IsValid = false;

    // Web properties
    IsSelected = false;
    ZIndex = 1;
}
